import React, { useState, useEffect } from 'react';
import { useAppContext } from '../context/AppContext';
import axios from 'axios';
import TranscriptModal from './TranscriptModal';
import '../styles/VoiceTranscriptsCard.css';

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';

const VoiceTranscriptsCard = () => {
  const { user } = useAppContext();
  const [transcripts, setTranscripts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedTranscript, setSelectedTranscript] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    fetchTranscripts();
  }, []);

  const fetchTranscripts = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/guest/voice-transcripts`, {
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
      });
      
      if (response.data.success) {
        setTranscripts(response.data.transcripts);
      }
    } catch (error) {
      console.error('Error fetching transcripts:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleTranscriptClick = (transcript) => {
    // Don't open modal for error or no-answer transcripts
    if (isErrorTranscript(transcript) || isNoAnswerTranscript(transcript)) {
      return;
    }
    setSelectedTranscript(transcript);
    setShowModal(true);
  };

  const isErrorTranscript = (transcript) => {
    return transcript.transcript === 'error' || 
           (typeof transcript.transcript === 'string' && 
            transcript.transcript.toLowerCase().includes('error'));
  };

  const isNoAnswerTranscript = (transcript) => {
    return transcript.transcript === "didn't answer" || 
           (typeof transcript.transcript === 'string' && 
            transcript.transcript.toLowerCase().includes("didn't answer"));
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedTranscript(null);
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('he-IL', {
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <>
      <div className="admin-dashboard-card">
        <div className="card-header">
          <div>שיחות קוליות שבוצעו</div>
          <span className="count-badge">{transcripts.length}</span>
        </div>
        
        <div className="card-content">
          {loading ? (
            <div className="loading">טוען שיחות...</div>
          ) : transcripts.length === 0 ? (
            <div className="empty-state">
              <p>לא נמצאו שיחות קוליות עדיין</p>
            </div>
          ) : (
            <div className="transcript-list">
              {transcripts.map((transcript) => {
                const isError = isErrorTranscript(transcript);
                const isNoAnswer = isNoAnswerTranscript(transcript);
                const isClickable = !isError && !isNoAnswer;
                
                return (
                  <div 
                    key={transcript.id}
                    className={`transcript-item ${isError ? 'error' : ''} ${isNoAnswer ? 'no-answer' : ''}`}
                    onClick={() => handleTranscriptClick(transcript)}
                    style={{ cursor: isClickable ? 'pointer' : 'default' }}
                  >
                    <div className="transcript-info">
                      <div className="guest-name">{transcript.userName || 'לא ידוע'}</div>
                      <div className="guest-phone">{transcript.userPhone}</div>
                    </div>
                    <div className="transcript-meta">
                      <div className="call-date">{formatDate(transcript.createdAt)}</div>
                      <div className="view-icon">
                        {isError ? '❌' : isNoAnswer ? '⚠️' : '📞'}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>

      {showModal && (
        <TranscriptModal 
          transcript={selectedTranscript}
          onClose={closeModal}
        />
      )}
    </>
  );
};

export default VoiceTranscriptsCard;
